import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class FsWatchdog extends SnModel {
  @Expose()
  public city: any;

  @Expose({ name: 'convictiontype' })
  public conviction: any;

  @Expose()
  public dob: any;

  @Expose()
  public latitude: any;

  @Expose()
  public longitude: any;

  @Expose()
  public name: any;

  @Expose({ name: 'offenderid' })
  public id: any;

  @Expose()
  public photo: any;

  @Expose()
  public race: string;

  @Expose()
  public sex: any;

  @Expose()
  public state: any;

  @Expose({ name: 'street1' })
  public street: any;

  @Expose()
  public weight: any;

  @Expose()
  public zipcode: any;

  constructor(data?: any) {
    super();
    this.fromJSON(data);
  }
}
